module.exports = __webpack_public_path__ + "img/twitter.b61c0b1c.svg";